import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import NoteItem from './NoteItem';
import styles from './styles';

const getItem = (type) => {
  // Note, Medical, FeedChange, LocationChange, ProfileChange, Competition,

  // TODO in the future we might build out more specific items based on note type and specific fields in information
  switch (type) {
    case 'Note':
      return NoteItem;
    case 'Medical':
      return NoteItem;
    case 'FeedChange':
      return NoteItem;
    case 'LocationChange':
      return NoteItem;
    case 'ProfileChange':
      return NoteItem;
    case 'Competition':
      return NoteItem;
    case 'Billing':
      return NoteItem;
    case 'TackEquipment':
      return NoteItem;
    case 'Farrier':
      return NoteItem;
    default:
      return NoteItem;
  }
};

export class NoteItemComponent extends React.Component {
  render() {
    const { note } = this.props;

    const Item = getItem(note.type);

    return (
      <Item {...this.props} />
    );
  }
}

NoteItemComponent.propTypes = {
  note: PropTypes.object,
  horseId: PropTypes.string.isRequired,
  pinnedHorseNoteId: PropTypes.string,
  isAdmin: PropTypes.bool,
  condensed: PropTypes.bool,
  classes: PropTypes.object,
};

NoteItemComponent.defaultProps = {
  note: {},
  isAdmin: false,
  pinnedHorseNoteId: null,
  condensed: false,
  classes: {},
};

export default withStyles(styles)(NoteItemComponent);
